import { getByPage } from '@api/service'
import { ApigetReceiveMessage } from '@api/service'
export default {
    namespaced: true,
    state: {
        //站内信列表
        messageList: [],
        messagePage: 1,
        messageTotalPage: 1,
        //公告列表
        noticeList: [],
        noticePage: 1,
        noticeTotalPage: 1,
        // 上次弹窗时间
        showHomePopTime: null, //null 未弹出过
        showNoticeModal: false,//是否显示公告

    },
    mutations: {

        setshowNoticeModal(state, payload) {
            state.showNoticeModal = payload;
        },
        setshowMessageModal(state, payload) {
            state.showMessageModal = payload;
        },
        setMessageList(state, payload) {
            state.messageList = payload
        },
        setNoticeList(state, payload) {
            state.noticeList = payload
        },
        setNoticeTotalPage(state, payload) {
            state.noticeTotalPage = payload
        },
        setMessageTotalPage(state, payload) {
            state.messageTotalPage = payload
        },
        setNoticePage(state, payload) {
            state.noticePage = payload
        },
        setMessagePage(state, payload) {
            state.messagePage = payload
        },
        setShowHomePopTime(state, payload) {
            state.showHomePopTime = new Date().getTime()
        },
    },
    actions: {
        getNoticeByPage({ commit }, param) {
            //获取公告
            return new Promise(async (resolve, reject) => {

                const res = await getByPage(param);
                if (res.code == '12200') {
                    commit('setNoticeList', res.data)
                    // commit('setNoticePage',res.data.currPage)
                    // commit('setNoticeTotalPage',res.data.totalPage)
                }
                resolve(res)

            })
        },
        getMailByPage({ commit }, param) {
            //获取站内信
            return new Promise(async (resolve, reject) => {

                const res = await ApigetReceiveMessage(param);
                if (res.code == '12200') {
                    // commit('setMessageList',res.data)
                    // commit('setMessagePage',res.data.currPage)
                    // commit('setMessageTotalPage',res.data.totalPage)
                }
                resolve(res)

            })
        },
        /**
         * 判断是否显示公告
         */
        checkShowNotice({ state, commit, rootState }, status) {

            let lottery_config
            try {
                lottery_config = Vue.prototype.$tools.deepMerge(rootState.app.defaultNoticeConfig, rootState.app.appConfig.notice_config.configValue);
            } catch {
                lottery_config = rootState.app.defaultNoticeConfig
            }
            const now = new Date().getTime()
            const oldTime = state.showHomePopTime
            const key = status === 2 ? 'onLogin' : 'onInit'////1是初始化加载2是登录之后判断
            if (lottery_config[key].isEnable === 0) return;//未开启
            if (lottery_config[key].trigger === 1) {
                //立即触发不判断间隔时间
                commit('setshowNoticeModal', true)
                return;
            } else {
                //不立即触发，就要判断间隔时间
                let type
                if (oldTime == null) {
                    type = true
                } else {
                    type = now - oldTime > lottery_config.interval
                }
                if (type) {
                    commit('setshowNoticeModal', true)
                    //当触发时是否更新记录的弹窗时间
                    if (lottery_config[key].updateInterval === 1) {
                        commit('setShowHomePopTime')
                    }
                } else {
                    commit('setshowNoticeModal', false)
                }
            }
        },
    },
    getters: {
        showNoticeModal(state) {
            return state.showNoticeModal
        },
        isShowHomePop(state) {
            const now = new Date()
            const oldTime = new Date(state.showHomePopTime)
            if (oldTime == null) {
                return true
            } else {
                return now.toDateString() != oldTime.toDateString()
            }
        }
    }

}